<template>
    <main-content with_go_back_bar>
        <shareholder-form :submit="create"
                          :submit_btn_text="$t('btn.create')"
                          :form_data="form_data"
        >
        </shareholder-form>
    </main-content>
</template>

<script>
    import mainContent from "@/components/main-content";
    import shareholderForm from './components/shareholder-form'
    import {walletService} from "@/common/api.service";

    export default {
        components: {
            mainContent,
            shareholderForm,
        },
        data() {
            return {
                form_data: {
                    first_name: '',
                    last_name: '',
                    account_numbers: [''],
                    wallet_hashid: '',
                },
            };
        },
        methods: {
            create() {
                let account_numbers = [];

                for (let item of this.form_data.account_numbers) {
                    if (item !== '' && item != null) {
                        account_numbers.push(item);
                    }
                }

                let params = {
                    first_name: this.form_data.first_name,
                    last_name: this.form_data.last_name,
                    wallet_hashid: this.form_data.wallet_hashid,
                    account_numbers: account_numbers,
                };

                walletService.shareholderCreate(params).then(res => {
                    this.$router.push('/shareholders');
                });
            },
        },
    }
</script>
